@if (canShow() && (!!items?.length || client.isCms)) {
<div class="wrap overflow-hidden local-model-carousel"
     [style.--carousel-slide-width]="client.isS ? 202 : 326"
     [gtmTrackViewItemList]="gtmTrackViewItemList"
     [gtmTrackViewItemListOff]="client.isCms">
    @let showArrows = !component.carousel_marquee && canLoop && showCarousel;
    @let showTitle = component.title || component.cta_text;

    <!-- title -->
    @if (showTitle || showArrows) {
    <div class="w-12 flex flex-justify-between p-t">
        <div class="flex flex-middle">
            <span [style.color]="component.title_color || null"
                  [sizeClass]="'!S:h2, S:h3'"
                  *iCms="'title' of component; content: 'html'; tag: component.title_tag || 'h2'; skipEmpty: true"></span>
            @if (component.title) {
            &nbsp;
            }
            @if (component.cta_text) {
            <href [link]="component.cta_link">
                <span class="link-2 fs-3"
                      [style.color]="component.cta_color || null"
                      *iCms="'cta_text' of component; content: 'html'; skipEmpty: true">
                </span>
            </href>
            }
        </div>
        @if (showArrows) {
        <!--  slider control  -->
        <div class="flex flex-middle m-r--2"
             [style.color]="component.title_color || null">
            <button class="flex flex-middle p-r-1 p-l-1 cursor-pointer"
                    [ngClass]="'model-carousel-prev-' + uid"
                    role="button"
                    [disabled]="!swiper?.allowSlidePrev"
                    [attr.aria-label]="'Previous slide' | translate"
                    (click)="swiper?.slidePrev()">
                <i class="fs-4 icon-chevron-left"
                   aria-hidden="true"></i>
            </button>
            <button class="flex flex-middle p-r-1 p-l-1 cursor-pointer"
                    [ngClass]="'model-carousel-next-' + uid"
                    role="button"
                    [disabled]="!swiper?.allowSlideNext"
                    [attr.aria-label]="'Next slide' | translate"
                    (click)="swiper?.slideNext()">
                <i class="fs-4 icon-chevron-right"
                   aria-hidden="true"></i>
            </button>
        </div>
        }
    </div>
    }
    @if (showCarousel) {
    <custom-cursor class="w-12"
                   [color]="component.cursor_color"
                   [disabled]="client.isTouchy || touched || !canDrag">
        <ng-template #customCursorContent>
            <carousel class="w-12 m-t swiper-overflow-visible slides-per-view-auto"
                      [style.--carousel-slides-per-view-round]="slidesPerViewRound"
                      [style.--carousel-slides-per-view]="slidesPerView"
                      [style.--carousel-space-between.px]="spaceBetween"
                      [slidesPerView]="slidesPerView"
                      [slidesPerGroup]="1"
                      [spaceBetween]="spaceBetween"
                      [freeMode]="true"
                      [loop]="canLoop"
                      [marquee]="{
                        enabled: !!component.carousel_marquee,
                        bounce: !canLoop,
                        speed: component.carousel_marquee_speed || 1
                       }"
                      [navigation]="canLoop ? {
                           nextEl: '.model-carousel-next-' + uid,
                           prevEl: '.model-carousel-prev-' + uid
                       } : false"
                      [nested]="!!component.carousel_nested"
                      [mousewheel]="{
                        enabled: true,
                        forceToAxis: true,
                      }"
                      (afterInit)="afterInitHandle($event)"
                      (touchStart)="touchStartHandle()"
                      (activeIndexChange)="activeIndexChangeHandle($event)"
                      #carouselRef>
                @for (item of items; track $index) {
                <ng-template class="w-12 flex"
                             carouselSlide
                             let-data>
                    @switch (type) {
                    @case ('product') {
                    <product class="w-12 bg-col-w"
                             [model]="$any(item).model"
                             [modelView]="$any(item).modelView"
                             [altView]="$any(item).altView"
                             [disableCarousel]="true"
                             [hidePrice]="component.product_hide_price"
                             [hideName]="component.product_hide_name"
                             [hideLabel]="component.product_hide_label"
                             [hideVideo]="component.product_hide_video"
                             [listPosition]="$index"
                             [listId]="listId"
                             [listName]="listName"
                             [sizes]="client.isS ? '202px' : '326px'" />
                    }
                    @case ('category') {
                    <category class="w-12 bg-col-w"
                              [model]="$any(item).model" />
                    }
                    @case ('page') {
                    <cms-blog-post class="w-12 bg-col-w"
                                   [model]="$any(item).model" />
                    }
                    @case ('custom') {
                    <div class="w-12 pos-relative flex-column"
                         style="height: 100%;">
                        <href class="w-12 ratio-3-4"
                              [link]="$any(item).url">
                            <df-image-wrapper class="fill">
                                <img [dfImage]="$any(item).image"
                                     [priority]="(data.isActive || data.isNext || data.isPrev) && (component.cwvLoading === 'eager' || component.cwvPriority)"
                                     [ratio]="'ratio-3-4'"
                                     fill
                                     draggable="false"
                                     alt="">
                            </df-image-wrapper>
                        </href>
                        <div class="pos-relative flex-grow">
                            <a class="block p-t-3 left"
                               [routerLink]="$any(item).url">
                                <span [ngClass]="$any(item).textStyle"
                                      *iCms="'copy' of $any(item); tag: $any(item).forceTitleTag"></span>
                            </a>
                        </div>
                    </div>
                    }
                    }
                </ng-template>
                }
            </carousel>
        </ng-template>

        <!-- cursor -->
        <ng-template #customCursorIcon>
            {{'Drag' | translate}}
        </ng-template>
    </custom-cursor>
    } @else {
    <!-- product list -->
    <div class="m-t"
         [grid]="[2,2,4,4][client.sizeId]"
         (infiniteScroll)="listing?.increaseLimit()"
         [infinitScrollActive]="listing?.hasMore">
        @for (item of $any(items) | slice : 0 : limit; track $index) {
        <div>
            @switch (type) {
            @case ('product') {
            <product class="w-12 bg-col-w"
                     [model]="$any(item).model"
                     [modelView]="$any(item).modelView"
                     [altView]="$any(item).altView"
                     [disableCarousel]="true"
                     [hidePrice]="component.product_hide_price"
                     [hideName]="component.product_hide_name"
                     [hideLabel]="component.product_hide_label"
                     [hideVideo]="component.product_hide_video"
                     [listPosition]="$index"
                     [listId]="listId"
                     [listName]="listName"
                     [sizes]="client.isS ? '202px' : '326px'" />
            }
            @case ('category') {
            <category class="w-12 bg-col-w"
                      [model]="$any(item).model" />
            }
            @case ('page') {
            <cms-blog-post class="w-12 bg-col-w"
                           [model]="$any(item).model" />
            }
            @case ('custom') {
            <div class="w-12 pos-relative flex-column"
                 style="height: 100%;">
                <href class="w-12 ratio-3-4"
                      [link]="$any(item).url">
                    <img class="z-2"
                         [dfImage]="$any(item).image"
                         [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
                         [ratio]="'ratio-3-4'"
                         fill
                         draggable="false"
                         alt="">
                </href>
                <div class="pos-relative flex-grow">
                    <a class="block p-t-3 left"
                       [routerLink]="$any(item).url">
                        <span [ngClass]="$any(item).textStyle"
                              *iCms="'copy' of $any(item); tag: $any(item).forceTitleTag"></span>
                    </a>
                </div>
            </div>
            }
            }
        </div>
        }
    </div>
    }
</div>
}